import { useState } from "react";
import { AppShell } from "../components/layout/AppShell";
import { DataTable, type Column } from "../components/ui/DataTable";
import { Badge } from "../components/ui/Primitives";
import { Input, Select } from "../components/ui/Fields";
import { useOffsetList } from "../hooks/useOffsetList";
import type { AgencyAuditRow } from "../api/types";

const short = (v: unknown) => (v == null ? "—" : typeof v === "string" ? v : JSON.stringify(v));

/** Round 54 — read-only agency & host audit trail (agency_audit_logs). */
export function AgencyAuditPage() {
  const [agency, setAgency] = useState("");
  const [entity, setEntity] = useState("");
  const [action, setAction] = useState("");
  const { rows, isLoading, error, page, setPage, hasNextPage, reload, pageSize } = useOffsetList<AgencyAuditRow>("/admin/agency-audit", { agency_id: agency.trim(), entity, action: action.trim() });
  const columns: Column<AgencyAuditRow>[] = [
    { header: "When", render: (r) => new Date(r.created_at).toLocaleString() },
    { header: "Admin", render: (r) => r.admin_email ?? "—" },
    { header: "Action", render: (r) => <Badge tone="gold">{r.action}</Badge> },
    { header: "Target", render: (r) => <span className="text-xs">{r.entity_type} · {r.target_label ?? "—"}</span> },
    { header: "Old", render: (r) => <span className="block max-w-[14rem] truncate text-xs text-ink-faint" title={short(r.old_value)}>{short(r.old_value)}</span> },
    { header: "New", render: (r) => <span className="block max-w-[14rem] truncate text-xs text-ink-faint" title={short(r.new_value)}>{short(r.new_value)}</span> },
    { header: "Reason", render: (r) => r.reason ?? "—" },
  ];
  return (
    <AppShell title="Agency Audit Logs">
      <div className="mb-4 grid grid-cols-1 gap-2 md:grid-cols-3">
        <Input placeholder="Agency ID (7 digits)" value={agency} onChange={(e) => setAgency(e.target.value)} />
        <Select value={entity} onChange={(e) => setEntity(e.target.value)}><option value="">Agencies + Hosts</option><option value="agency">Agency</option><option value="host">Host</option></Select>
        <Input placeholder="Action (e.g. agency.created, host.added)" value={action} onChange={(e) => setAction(e.target.value)} />
      </div>
      <DataTable columns={columns} rows={rows} keyField={(r) => r.id} isLoading={isLoading} error={error} onRetry={reload}
        emptyTitle="No agency activity recorded" pagination={{ page, pageSize, hasNextPage, onPageChange: setPage }} />
    </AppShell>
  );
}
